import { render, staticRenderFns } from "./FormZone.vue?vue&type=template&id=6ef3638f"
import script from "./FormZone.vue?vue&type=script&lang=js"
export * from "./FormZone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports